export enum ReportSessionModes {
  SEND = 'SEND',
  NEWTAB = 'NEWTAB',
  END = 'END',
}

interface TableauReport {
  url: string;
  ticket: string;
}

export default TableauReport;

export type TableauReportType = {
  sortOrder: number;
  reportType: string;
  reportTypeID: number;
};

export type TableauReportCardResponse = {
  sortOrder: number;
  workbookHash: string;
  workbookName: string;
  workbookDescription: string;
  tableauCategoryID: number;
  tableauCategory: string;
  reportRole: string;
  programFilter: string;
  programFilterID: number;
};

export type TableauReportCard = TableauReportCardResponse & {
  isCoreMeasures: boolean;
};

export type TableauParameter = {
  workbookHash: string;
  workbookName: string;
  reportRole: string;
  tableauParameterID: string;
  parameterName: string;
  parameterValue: string;
  parameterLabel: string;
  parameterDataType: string;
};

export type ReportSessionData = {
  trackingID: string;
  workbookURL?: string;
  viewURL?: string;
  switchToTabName?: string;
  dateType?: string;
  dataRange?: string;
  populationTreatmentID?: string;
  populationTypeID?: string;
  treatmentTypeID?: string;
  programID?: string;
  endYear?: string;
  endMonth?: string;
  endDay?: string;
  startYear?: string;
  startMonth?: string;
  startDay?: string;
  printed?: string;
  aid?: string;
  notes?: string;
  tableauURL?: string;
};
